import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { useTranslationApp } from "../../../../lib/i18next";
import { logoPlatform } from "../../../../utils/string";
import { formatAdSpendPlatform, formatAdSpendUsd } from "./adSpendDisplay";

const AdSpendPlatformIcons = ({ platforms = [] }) => {
  const { t, i18n } = useTranslationApp();
  const language = i18n.language;

  return (
    <Box sx={{ display: "flex", gap: 0.75, alignItems: "center" }}>
      {platforms.map((item) => (
        <Tooltip
          key={item.platform}
          title={`${formatAdSpendPlatform({ platform: item.platform, t })} ${formatAdSpendUsd({ value: item.spendUSD, language })}`}
        >
          <Box
            component="img"
            src={logoPlatform(item.platform)}
            alt={formatAdSpendPlatform({ platform: item.platform, t })}
            sx={{ width: 18, height: 18, objectFit: "contain" }}
          />
        </Tooltip>
      ))}
    </Box>
  );
};

export default AdSpendPlatformIcons;
